import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VMain,[_c('div',{staticClass:"wrapper"},[_c(VSheet,{attrs:{"color":"Greyscale_002"}},[_c(VSheet,{staticClass:"mx-auto h-100",attrs:{"max-width":"550","outlined":""}},[_c('navbar-component'),_c('div',{staticClass:"container-fluid py-4"},[_c('div',{staticClass:"px-xl-4"},[_c('router-view')],1)])],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }